import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdmissionDashboardComponent } from './pages/dashboard/admission-dashboard.component';
import { AdmissionCreationComponent } from './pages/admission-creation/admission-creation.component';
import { tenantRouteGuard } from '../../tenant-config/tenant-route.guard';


const routes: Routes = [
   {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full'
   },
   {
      path: 'dashboard',
      component: AdmissionDashboardComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Dashboard', tenantRoute: '/app/admisiones/dashboard' }
   },
   {
      path: 'crear',
      component: AdmissionCreationComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Crear', tenantRoute: '/app/admisiones/crear' }
   },
   {
      path: 'listado',
      component: AdmissionDashboardComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Listado', tenantRoute: '/app/admisiones/listado' }
   },
   {
      path: 'archivadas',
      component: AdmissionDashboardComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Archivadas', tenantRoute: '/app/admisiones/archivadas' }
   },
];

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule]
})
export class AdmissionsRoutingModule { }
